import React from "react";
import PropTypes from "prop-types";

import "./NotificationError.sass";

function NotificationError({ errorMessage, classWrapper, classText }) {
  return (
    <article className={classWrapper}>
      <p className={classText}>{errorMessage}</p>
    </article>
  );
}

NotificationError.propTypes = {
  errorMessage: PropTypes.string,
  classWrapper: PropTypes.string,
  classText: PropTypes.string,
};
NotificationError.defaultProps = {
  errorMessage: "",
  classWrapper: "",
  classText: "",
};

export default NotificationError;
